import { map } from 'rxjs';

import { ajaxGet } from 'common/ajax';

const ajaxGetResponse = (url) => ajaxGet(url).pipe(map((ajaxResponse) => ajaxResponse.response));

export { ajaxGetResponse, ajaxGetResponse as ajaxGetCachedResponse };
